import { Modal } from "components";
import { forwardRef, useEffect, useState} from 'react';
import { ZTextInput } from "components/ZTextInput";
import { ZSingleSelectDropdown } from "components/ZSingleSelectDropdown";
import { ZNumberInput } from "components/ZNumberInput";

export type CatalogueBulkEditPopupProps = {
    showPopup: boolean;
    closeBulkEditPopup: () => void; 
    ActionUpdate: (valuesToUpdate:  CatalogueDataUpdate)=> void;
}

interface CatalogueDataUpdate {
    promoType: number | null;
    quantity: number | null;
    value: number | null;
}

export const CatalogueBulkEditPopup = forwardRef((props: CatalogueBulkEditPopupProps, ref)=>{
    const [quantity, setQuatity] = useState<number | null>(null);
    const [promoType, setPromoType] = useState<number|null>(null);
    const [value, setValue] = useState<number | null>(null);
    const selectorOptions = [{ id: -1, value: "" },{ id: 0, value: "Buy For X" }, { id: 1, value: "Buy X or more get % off" }];


    useEffect(()=>{
        setQuatity(null);
        setPromoType(null);
        setValue(null);
    },[props.showPopup]);
return(
    <>
        <Modal
                title="Bulk Edit"
                show={props.showPopup}
                buttonType="primary"
                buttonText={"Continue"}
                buttonCloseText="Cancel"
                handleSubmit={() => {
                    props.ActionUpdate({ promoType: promoType, quantity: quantity, value: value });
                }}
                handleClose={() => {
                    props.closeBulkEditPopup();
                }}
                description={
                    <>
                        <ZSingleSelectDropdown 
                            options={selectorOptions}
                            optionKey={s => s.id}
                            containerClassName="pt-2"
                            value={promoType == null? selectorOptions.find((x) => x.id == -1):selectorOptions.find((x) => x.id == promoType)}
                            display={s => s.value}
                            onSelectionChange={s => s && setPromoType(s.id)}
                            
                            placeholder="Promo Type"
                            label="Promo Type:"
                            hasSearch
                        />
                        <div className="pt-2">
                            <ZTextInput
                                label="X:"
                                type="number"
                                placeholder="Enter Quantity"
                                value={quantity?.toString() ?? ""}
                                onChange={(e) =>
                                    setQuatity(parseInt(e))
                                }
                            />
                        </div>
                        <div className="pt-2">
                            <ZNumberInput
                                label="Value:"
                                placeholder="Enter Amount"
                                onChange={(e) => setValue(e == undefined? null: e)} 
                                type="decimal"/>
                        </div>
                    </>
                }
            />
        </>
    );
});